import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const PAGE_DESCRIPTION_FONT_SIZE = "14px";
const TABLE_FONT_SIZE = "13.5px";
const TOOLTIP_ICON_FONT_SIZE = "14px";

export const useValuePageStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    backgroundColor: projectIqTokens.bg,
    fontFamily: projectIqTokens.fontFamily,
    padding: designTokens.spacing[8],
  },
  content: {
    maxWidth: "800px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[6],
    width: "100%",
  },
  description: {
    fontSize: PAGE_DESCRIPTION_FONT_SIZE,
    color: projectIqTokens.muted,
    lineHeight: String(designTokens.lineHeight.normal),
    margin: "0",
  },
  linksBar: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: designTokens.spacing[2],
  },
  addNewButton: {
    alignSelf: "flex-end",
  },
  externalLink: {
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.teal,
    textDecoration: "none",
    ":hover": {
      color: projectIqTokens.tealInk,
      textDecoration: "underline",
    },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
      borderRadius: "2px",
    },
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: TABLE_FONT_SIZE,
    fontFamily: projectIqTokens.fontFamily,
  },
  tableHead: {
    backgroundColor: projectIqTokens.bg2,
  },
  tableHeaderCell: {
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
    textAlign: "left",
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.muted,
    borderBottom: `1px solid ${projectIqTokens.line}`,
    fontSize: designTokens.fontSize.xs,
  },
  tableHeaderCellWithTooltip: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
  },
  tableRow: {
    borderBottom: `1px solid ${projectIqTokens.line}`,
    ":hover": {
      backgroundColor: projectIqTokens.bg2,
    },
  },
  tableCell: {
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
    verticalAlign: "top",
    color: projectIqTokens.ink,
  },
  tableCellMuted: {
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
    verticalAlign: "top",
    color: projectIqTokens.muted,
  },
  actionsCell: {
    display: "flex",
    gap: designTokens.spacing[1],
    justifyContent: "flex-end",
  },
  iconButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: projectIqTokens.faint,
    borderRadius: designTokens.borderRadius.sm,
    padding: designTokens.spacing[1],
    ":hover": {
      color: projectIqTokens.ink,
      backgroundColor: projectIqTokens.bg2,
    },
  },
  deleteButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: projectIqTokens.faint,
    borderRadius: designTokens.borderRadius.sm,
    padding: designTokens.spacing[1],
    ":hover": {
      color: projectIqTokens.rust,
    },
  },
  adminListWrapper: {
    marginLeft: `-${designTokens.spacing[6]}`,
    marginRight: `-${designTokens.spacing[6]}`,
  },
  emptyRow: {
    color: projectIqTokens.muted,
    textAlign: "center",
    padding: designTokens.spacing[6],
  },
  tooltipIcon: {
    color: projectIqTokens.muted,
    fontSize: TOOLTIP_ICON_FONT_SIZE,
    cursor: "default",
    display: "flex",
    alignItems: "center",
  },
  skeletonLinksBar: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
  },
  skeletonLink: {
    height: "14px",
    borderRadius: designTokens.borderRadius.sm,
  },
});
